import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import { SearchResult } from './hooks/useFaqSearch';
import { LinkQuestion } from './LinkQuestion';
import { Link } from '@/components/links';
import Image from 'next/image';
import ChevronRightIcon from '@/assets/icons/heroIcons/Chevron-right.svg';
import { LINKS } from '@/constants/links';
import { FilledButton } from '@/components/buttons';
import { Category as CategoryType } from './NextCategory';
import ViewGridIcon from '@/assets/icons/heroIcons/View-grid.svg';
function Category(props) {
  const $ = _c(12);
  const t0 = `faqCategorySearchResult${props.slug}`;
  const t1 = `faqCategorySearchResult${props.slug}`;
  let t2;
  if ($[0] !== props.icon || $[1] !== props.title) {
    t2 = props.icon && <Image width={40} height={40} src={props.icon} alt={props.title} />;
    $[0] = props.icon;
    $[1] = props.title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props.title) {
    t3 = <h3 className="text-sm font-semibold md:text-base">{props.title}</h3>;
    $[3] = props.title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronRightIcon className="ml-auto min-h-[24px] min-w-[24px] text-blue-500" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props.slug || $[7] !== t0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t5 = <Link analyticsParam={t0} testId={t1} to={props.slug} key={props.slug} className="shadow-card flex max-w-sm items-center gap-3 rounded-2xl bg-white p-3 text-gray-900 no-underline transition-shadow hover:shadow-xs">{t2}{t3}{t4}</Link>;
    $[6] = props.slug;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export function SearchResults(props) {
  const $ = _c(49);
  const {
    t
  } = useTranslation("faq");
  if (props.categories.length === 0 && props.questions.length === 0) {
    let t0;
    if ($[0] !== t) {
      t0 = t("searchResults.noResults.title");
      $[0] = t;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== t0) {
      t1 = <h3 className="mb-4 text-base font-semibold whitespace-normal md:text-xl">{t0}</h3>;
      $[2] = t0;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== t) {
      t2 = t("searchResults.noResults.text1");
      $[4] = t;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== t2) {
      t3 = <li className="whitespace-normal">{t2}</li>;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Link testId="faqSearchNoResultsContact" analyticsParam="faqSearchNoResultsContact" to={LINKS().contact} />;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t) {
      t5 = <li className="whitespace-normal"><Trans t={t} i18nKey="searchResults.noResults.text2">{t4}</Trans></li>;
      $[9] = t;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
      t6 = <ul className="mb-6 list-inside list-disc marker:text-blue-500">{t3}{t5}</ul>;
      $[11] = t3;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== t) {
      t7 = t("searchResults.noResults.topCategories");
      $[14] = t;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t7) {
      t8 = <h3 className="mb-4 text-base font-semibold md:text-xl">{t7}</h3>;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== props.noResultCategories) {
      t9 = props.noResultCategories.map(_temp);
      $[18] = props.noResultCategories;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = LINKS();
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    const t11 = t10.faq;
    const t12 = props.onClean;
    let t13;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <ViewGridIcon className="h-6 w-6 md:h-10 md:w-10" />;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    let t14;
    if ($[22] !== t) {
      t14 = t("searchResults.noResults.allCategories");
      $[22] = t;
      $[23] = t14;
    } else {
      t14 = $[23];
    }
    let t15;
    if ($[24] !== props.onClean || $[25] !== t14) {
      t15 = <FilledButton analyticsParam="noResultsAllCategories" testId="noResultsAllCategories" to={t11} onClick={t12} className="w-full md:col-span-2 lg:w-full" icon={t13}>{t14}</FilledButton>;
      $[24] = props.onClean;
      $[25] = t14;
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    let t16;
    if ($[27] !== t15 || $[28] !== t9) {
      t16 = <div className="grid gap-4 md:grid-cols-2">{t9}{t15}</div>;
      $[27] = t15;
      $[28] = t9;
      $[29] = t16;
    } else {
      t16 = $[29];
    }
    let t17;
    if ($[30] !== t1 || $[31] !== t16 || $[32] !== t6 || $[33] !== t8) {
      t17 = <section className="relative z-10 mx-auto flex max-w-192 flex-col px-4 pb-8">{t1}{t6}{t8}{t16}</section>;
      $[30] = t1;
      $[31] = t16;
      $[32] = t6;
      $[33] = t8;
      $[34] = t17;
    } else {
      t17 = $[34];
    }
    return t17;
  }
  let t0;
  if ($[35] !== t) {
    t0 = t("searchResults.title");
    $[35] = t;
    $[36] = t0;
  } else {
    t0 = $[36];
  }
  let t1;
  if ($[37] !== t0) {
    t1 = <h2 className="font-semibold lg:text-xl">{t0}</h2>;
    $[37] = t0;
    $[38] = t1;
  } else {
    t1 = $[38];
  }
  let t2;
  if ($[39] !== props.categories || $[40] !== t) {
    t2 = props.categories.length > 0 && <div><h3 className="text-light-gray-500 mb-3 text-sm font-semibold lg:text-base">{t("searchResults.category")}</h3><div className="grid gap-2">{props.categories.map(_temp2)}</div></div>;
    $[39] = props.categories;
    $[40] = t;
    $[41] = t2;
  } else {
    t2 = $[41];
  }
  let t3;
  if ($[42] !== props.questions || $[43] !== t) {
    t3 = props.questions.length > 0 && <div><h3 className="text-light-gray-500 mb-3 text-sm font-semibold lg:text-base">{t("searchResults.question")}</h3><div className="grid gap-4 md:mb-32">{props.questions.map(_temp3)}</div></div>;
    $[42] = props.questions;
    $[43] = t;
    $[44] = t3;
  } else {
    t3 = $[44];
  }
  let t4;
  if ($[45] !== t1 || $[46] !== t2 || $[47] !== t3) {
    t4 = <section className="relative z-10 mx-auto flex max-w-192 flex-col gap-8 px-4 pb-8">{t1}{t2}{t3}</section>;
    $[45] = t1;
    $[46] = t2;
    $[47] = t3;
    $[48] = t4;
  } else {
    t4 = $[48];
  }
  return t4;
}
function _temp3(question) {
  return <LinkQuestion key={question.slug} slug={question.slug} title={question.title} />;
}
function _temp2(category_0) {
  return <Category key={category_0.slug} {...category_0} />;
}
function _temp(category) {
  return <FilledButton key={category._id} analyticsParam={`noResultsCategory${category._id}`} testId={`noResultsCategory${category._id}`} to={LINKS().faqCategory(category.slug.current || "")} className="w-full md:col-span-1 lg:w-full" icon={category.icon && category.icon.asset?.url ? <Image alt={category.name} src={category.icon.asset.url} width={40} height={40} /> : undefined}>{category.name}</FilledButton>;
}